<template>
  <div id="nav" class="bg-red-500">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>
</template>